class OfferCountdownBar extends HTMLElement {
  connectedCallback() {
    this.storageKey = 'offer-countdown-bar-closed';

    if (sessionStorage.getItem(this.storageKey) === '1') {
      this.remove();
      return;
    }

    this.endTime = new Date(this.dataset.end).getTime();

    if (isNaN(this.endTime)) {
      this.remove();
      return;
    }

    this.timerEl = this.querySelector('.offer-countdown-bar__timer');
    this.closeBtn = this.querySelector('.offer-countdown-bar__close');

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => {
        sessionStorage.setItem(this.storageKey, '1');
        this.remove();
      });
    }

    this.tick();
    this.interval = setInterval(this.tick.bind(this), 1000);
  }

  disconnectedCallback() {
    if (this.interval) clearInterval(this.interval);
  }

  tick() {
    const diff = this.endTime - Date.now();

    if (diff <= 0) {
      clearInterval(this.interval);
      this.remove();
      return;
    }

    const day = 1000 * 60 * 60 * 24;
    const hour = 1000 * 60 * 60;
    const minute = 1000 * 60;

    const days = Math.floor(diff / day);
    const hours = Math.floor((diff % day) / hour);
    const minutes = Math.floor((diff % hour) / minute);
    const seconds = Math.floor((diff % minute) / 1000);

    const pad = (n) => (n < 10 ? '0' + n : String(n));

    this.timerEl.innerHTML = [
      ['Days', days],
      ['Hrs', hours],
      ['Min', minutes],
      ['Sec', seconds]
    ]
      .map(
        ([label, value]) =>
          `<span class="offer-countdown-bar__item"><span class="offer-countdown-bar__value">${pad(value)}</span><span class="offer-countdown-bar__label">${label}</span></span>`
      )
      .join('<span class="offer-countdown-bar__sep">:</span>');
  }
}

customElements.define('offer-countdown-bar', OfferCountdownBar);
